import { Button } from "@/components/ui/button";
import {
  ArrowRight,
  ArrowLeft,
} from "lucide-react";

export function StepShell({
  title,
  subtitle,
  children,
  onBack,
  onNext,
  nextLabel = "Continue",
  disableNext = false,
  hideBack = false,
  testId,
}) {
  return (
    <div
      data-testid={testId}
      className="rounded-3xl bg-white border border-gray-200 p-6 md:p-10 shadow-[0_10px_40px_rgba(15,45,82,0.06)]"
    >
      <span className="text-[11px] uppercase tracking-[0.18em] font-bold text-[#D4AF37]">
        Section
      </span>

      <h2 className="mt-2 text-2xl md:text-3xl font-extrabold font-heading tracking-tight text-[#0F2D52]">
        {title}
      </h2>

      {subtitle && (
        <p className="mt-2 text-sm text-gray-600 max-w-2xl">
          {subtitle}
        </p>
      )}

      <div className="mt-8">
        {children}
      </div>

      <div className="mt-10 flex items-center justify-between gap-3">
        {!hideBack ? (
          <Button
            type="button"
            variant="ghost"
            onClick={onBack}
            data-testid="step-back"
            className="rounded-full text-gray-600"
          >
            <ArrowLeft className="h-4 w-4 mr-1" />
            Back
          </Button>
        ) : (
          <span />
        )}

        <Button
          type="button"
          onClick={onNext}
          disabled={disableNext}
          data-testid="step-next"
          className="rounded-full bg-[#0F2D52] hover:bg-[#0a1f38] text-white h-11 px-6 disabled:opacity-40"
        >
          {nextLabel}

          <ArrowRight className="ml-1 h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}

export function FormField({
  label,
  hint,
  required = false,
  children,
  className = "",
}) {
  return (
    <label
      className={`block ${className}`}
    >
      <span className="text-xs uppercase tracking-[0.14em] font-bold text-gray-600 mb-2 block">
        {label}

        {required && (
          <span className="text-red-500 ml-1">
            *
          </span>
        )}
      </span>

      {children}

      {hint && (
        <span className="text-[11px] text-gray-500 mt-1 block">
          {hint}
        </span>
      )}
    </label>
  );
}